/* eslint-disable no-console */
import usePopover from '@/components/ui/_refactor/popup/popover/use-popover';
import { useTicketingModalStore } from '@/features/ticketing/_shared/components/ticketing-modal/ticketing-modal.store';
import { TTicketComment } from '../../types/ticket-comment.type';
import { useTicketCommentActionsStore } from '../ticket-comment/ticket-comment.store';

const useTicketCommentPopover = () => {
  // HOOKS
  const { isPopoverOpen, handleChangePopoverOpen } = usePopover();
  const { actions: modalActions } = useTicketingModalStore();
  const ticketCommentActions = useTicketCommentActionsStore();

  // HELPERS

  // HANDLERS
  const handleEditComment = (ticketComment: TTicketComment) => {
    handleChangePopoverOpen(false);
    ticketCommentActions.setEditedTicketComment(ticketComment);
  };
  const handleDeleteComment = (ticketComment: TTicketComment, ticketId: string) => {
    handleChangePopoverOpen(false);
    modalActions.openModal('DeleteCommentModal', {
      ticketId: ticketId,
      commentId: ticketComment?.commentId,
    });
  };

  return {
    // POPOVER
    isPopoverOpen,
    handleChangePopoverOpen,

    // HANDLERS
    handleEditComment,
    handleDeleteComment,
  };
};

export default useTicketCommentPopover;
